import React from "react";
import Icon from "./Icon";
import type { IconProps } from "./IconProps";

const DocumentsIcon: React.FC<IconProps> = ({ className, title }) => {
  const svgPath = (
    <>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9 3.75H6.75A2.25 2.25 0 004.5 6v12A2.25 2.25 0 006.75 20.25h10.5A2.25 2.25 0 0019.5 18V8.25L14.25 3.75H9z"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M14.25 3.75V8.25h5.25"
      />
    </>
  );

  return (
    <Icon
      svgPath={svgPath}
      className={className}
      title={title}
      fill="none"
      strokeWidth={1.5}
    />
  );
};

export default DocumentsIcon;
